import { render, staticRenderFns } from "./attachments.vue?vue&type=template&id=2ea89828"
import script from "./attachments.ts?vue&type=script&lang=js&external"
export * from "./attachments.ts?vue&type=script&lang=js&external"
import style0 from "./attachments.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports